import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
// import { GameType } from '@/modules/promotion/type'
import { FormProvider } from 'react-hook-form'
import {
	FormControl,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from '@/common/ui/form'
import { Input } from '@/common/ui/input'
import { Button } from '@/common/ui/button'
import { partnerFormSchema, type PartnerFormValues } from './components'
// import { Card } from '@/common/ui/card'

// const GAME_TYPE_TRANSLATIONS: Record<GameType, string> = {
// 	[GameType.SLOT]: 'สล็อต',
// 	[GameType.FISHING]: 'เกมยิงปลา',
// 	[GameType.SPORT]: 'กีฬา',
// 	[GameType.LOTTO]: 'หวย',
// 	[GameType.CASINO]: 'คาสิโน',
// }

// const GAME_TYPES = [
// 	GameType.SLOT,
// 	GameType.CASINO,
// 	GameType.LOTTO,
// 	GameType.SPORT,
// 	GameType.FISHING,
// ] as const

interface PartnerFormProps {
	defaultValues?: Partial<PartnerFormValues>
	onSubmit: (data: PartnerFormValues) => void
	mode: 'create' | 'edit'
}

export function PartnerForm({
	defaultValues,
	onSubmit,
	mode,
}: PartnerFormProps) {
	const form = useForm<PartnerFormValues>({
		resolver: zodResolver(partnerFormSchema),
		defaultValues: {
			nickname: '',
			percentage: undefined,
			// rewards: GAME_TYPES.reduce(
			// 	(acc, type) => ({
			// 		...acc,
			// 		[type]: {
			// 			ratio: undefined,
			// 		},
			// 	}),
			// 	{},
			// ),
			...defaultValues,
		},
	})

	return (
		<FormProvider {...form}>
			<form
				onSubmit={form.handleSubmit(onSubmit)}
				className="space-y-4 sm:space-y-6"
			>
				{/* Main Form Fields - Mobile Responsive Grid */}
				<div className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-6">
					<FormField
						control={form.control}
						name="nickname"
						render={({ field }) => (
							<FormItem>
								<FormLabel>ชื่อ</FormLabel>
								<FormControl>
									<Input
										{...field}
										placeholder="กรอกชื่อพาร์ทเนอร์"
										value={field.value ?? ''}
									/>
								</FormControl>
								<FormMessage />
							</FormItem>
						)}
					/>

					<FormField
						control={form.control}
						name="percentage"
						render={({ field }) => (
							<FormItem>
								<FormLabel>
									เปอร์เซ็นต์การถือส่วนแบ่ง (%) (ต้องตามเก็บเอง)
								</FormLabel>
								<FormControl>
									<Input
										type="number"
										step={0.01}
										min={0}
										max={100}
										placeholder="กรอกเปอร์เซ็นต์"
										{...field}
										value={
											field.value !== null && field.value !== undefined
												? String(Number((field.value * 100).toFixed(4)))
												: ''
										}
										onChange={(e) => {
											const value = e.target.value
												? parseFloat(e.target.value)
												: null
											field.onChange(value !== null ? value / 100 : null)
										}}
									/>
								</FormControl>
								<FormMessage />
							</FormItem>
						)}
					/>
				</div>

				{/* Game Type Rewards Section - Mobile Responsive */}
				{/* <div className="space-y-3 sm:space-y-4">
					<div>
						<h3 className="text-sm font-semibold sm:text-base">
							เปอร์เซ็นต์แบ่งจากยอดเทิร์น
						</h3>
						<p className="text-xs text-muted-foreground sm:text-sm">
							*
							เปอร์เซ็นต์แบ่งจากยอดเทิร์นจะคิดเมื่อลูกสายเล่นด้วยกระเป๋าหลักเท่านั้น
						</p>
					</div>

					<Card className="grid grid-cols-1 gap-0 sm:grid-cols-2">
						{GAME_TYPES.map((gameType, index) => (
							<div
								key={gameType}
								className={`p-4 sm:p-5 ${
									index < GAME_TYPES.length - 1 ? 'border-b sm:border-b-0' : ''
								} ${
									index % 2 === 0 && index < GAME_TYPES.length - 1
										? 'sm:border-r'
										: ''
								}`}
							>
								<h4 className="mb-3 text-sm font-semibold tracking-wide sm:text-base">
									{GAME_TYPE_TRANSLATIONS[gameType]}
								</h4>

								<div className="w-full">
									<FormField
										control={form.control}
										name={`rewards.${gameType}.ratio`}
										render={({ field }) => (
											<FormItem>
												<FormLabel className="text-xs text-muted-foreground sm:text-sm">
													เปอร์เซ็นต์ (0-100%)
												</FormLabel>
												<FormControl>
													<Input
														type="number"
														placeholder="กรอกเปอร์เซ็นต์"
														step={0.01}
														min={0}
														max={100}
														{...field}
														value={
															field.value !== null && field.value !== undefined
																? String(Number((field.value * 100).toFixed(4)))
																: ''
														}
														className="bg-background text-sm"
														onChange={(e) => {
															const value = e.target.value
																? parseFloat(e.target.value)
																: null
															field.onChange(
																value !== null ? value / 100 : null,
															)
														}}
													/>
												</FormControl>
												<FormMessage />
											</FormItem>
										)}
									/>
								</div>
							</div>
						))}
					</Card>
				</div> */}

				{/* Submit Button - Mobile Responsive */}
				<div className="flex gap-4">
					<Button type="submit" variant="default" className="flex-1" size="lg">
						{mode === 'create' ? 'สร้างพาร์ทเนอร์' : 'แก้ไขพาร์ทเนอร์'}
					</Button>
				</div>
			</form>
		</FormProvider>
	)
}
